import React, { SelectHTMLAttributes } from 'react';

interface IOption {
  text: string;
  value: string | number;
}

interface IProperties extends SelectHTMLAttributes<HTMLSelectElement> {
  options: IOption[];
}

const Select = (properties: IProperties) => {
  const { options, ...remainingProperties } = properties;

  return (
    <select
      className="bg-transparent px-2 rounded-full border-transparent focus:outline-none active:outline-none"
      {...remainingProperties}
    >
      {options.map((option) => (
        <option
          key={option.value}
          className="bg-theme-gray"
          value={option.value}
        >
          {option.text}
        </option>
      ))}
    </select>
  );
};

export default Select;
